import GATSBY_COMPILED_MDX from "/home/runner/work/kidz-dental-care/kidz-dental-care/src/content/blog/oral-health/index.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {DefaultLayout} from '../layouts/DefaultLayout';
import styled from '@emotion/styled';
import {AltHero} from '../components/layout/Alt-Hero';
import {Seo} from '../components/layout/Seo';
const Template = (styled.div)``;
const Body = (styled.div)`
    margin-bottom: 64px;
    .mdx-image {
        margin: 32px auto;
        border-radius: 15px;
    }
    button {
        margin: 40px auto;
        a {
            text-decoration: none;
        }
    }

    h2 {
        color: #0096d7;
        margin-bottom: 16px;
        margin-top: 24px;
        font-size: 28px;
    }
    h3 {
        font-size: 16px;
        color: ${({theme}) => theme.colors.gray5};
        margin-bottom: 16px;
        margin-top: 16px;
    }
    p {
        font-size: 16px;
    }
    a {
        text-decoration: underline;
        color: #0096d7;
        transition: color 0.2s ease-in-out;
        &:hover {
            color: #0b6b95;
        }
    }

    ul {
        padding-left: 20px;
        margin-bottom: 16px;
    }
    li {
        line-height: 26px;
        margin-bottom: 8px;
        color: #3d3c3a;
    }
    p {
        margin-bottom: 16px;
    }
    .section {
        margin-top: 32px;
        margin-bottom: 16px;
        a {
            position: relative;
            bottom: 12px;
        }
    }
    iframe {
        margin: 0 auto 40px;
        border-radius: 15px;
    }
    @media (min-width: 1130px) {
        display: flex;
        flex-direction: column;
        .mdx-image {
            width: 896px;
        }
        iframe {
            width: 100%;
            height: 509px;
        }
    }
`;
const AltTemplate = ({data: {mdx: {frontmatter}}, children}) => {
  return React.createElement(Template, null, React.createElement(Seo, {
    title: `${frontmatter.title} | Santa Clarita, California | Kidz Dental Care`,
    description: frontmatter.description
  }), React.createElement(AltHero, {
    title: frontmatter.title,
    slug: frontmatter.slug
  }), React.createElement("div", {
    className: "container"
  }, React.createElement(Body, null, children)));
};
export const query = graphql`
    query ($id: String!) {
        mdx(id: { eq: $id }) {
            frontmatter {
                title
                slug
                type
                date
                category
            }
        }
    }
`;
AltTemplate.Layout = DefaultLayout;
AltTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(AltTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
